module.exports = __webpack_public_path__ + "img/seccion4.4.b83b471b.png";